export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "mappingTable.worker.2e2e302473304adb692b.worker.js");
}
